import routerOptions0 from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@4.0.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compile_8c3404432d91d59a9b7379e91026ecbb/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}